import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment-timezone'
import { capitalize } from 'lodash'
import { PanelNoteSections } from './PanelNoteSections'
import { CButton } from '@coreui/react-pro'
import NewProgressNoteAction from '../../../census/components/censusTable/NewProgressNoteAction'
import { VISIT_STATUS } from '../../../../../utils/statusConstants'
import { canSharedServiceProviderOpenNote } from '../../../../../utils/sharedChartFunctions'

export default function PanelNoteCard() {
  const panelEncounter = useSelector((state) => state.sidePanel.panelEncounter)
  const isLastEncounter = useSelector((state) => state.sidePanel.isLastEncounter)
  const panelChart = useSelector((state) => state.sidePanel.panelChart)
  const signed_on = useSelector((state) => state.sidePanel.panelChart?.signed_on)
  const signed_provider = useSelector((state) => state.sidePanel.panelChart?.signed_provider)

  const provider = useSelector((state) => state.user.provider)

  const [noteModal, showNoteModal] = useState(false)

  return (
    <div id={'PanelNoteCard'}>
      <div className={'d-flex flex-column '}>
        {signed_on && (
          <>
            <span style={{ fontSize: '0.9rem' }}>Signed On</span>
            <span> {moment(signed_on).tz('America/Los_Angeles').format('M.D.YYYY  h:mma z')}</span>
            <span>
              by {capitalize(signed_provider?.first_name)} {capitalize(signed_provider?.last_name)}
            </span>
          </>
        )}
        {!panelChart && canSharedServiceProviderOpenNote(panelEncounter, provider) && (
          <>
            <CButton onClick={() => showNoteModal(true)} className={'mt-4'}>
              Start a Note
            </CButton>
            {noteModal && (
              <NewProgressNoteAction
                isOpen={true}
                onToggle={showNoteModal}
                visit={{
                  ...panelEncounter,
                  visitId: panelEncounter._id,
                  status: isLastEncounter ? VISIT_STATUS.last : panelEncounter.status,
                  chart: panelChart,
                }}
              />
            )}
          </>
        )}
        {panelChart && !signed_on && <PanelNoteSections />}
      </div>
    </div>
  )
}
